import { render } from "./face-mesh-view.vue?vue&type=template&id=255bb6c0&scoped=true"
import script from "./face-mesh-view.vue?vue&type=script&lang=js"
export * from "./face-mesh-view.vue?vue&type=script&lang=js"

import "./face-mesh-view.vue?vue&type=style&index=0&id=255bb6c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255bb6c0"]])

export default __exports__